import React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import Appbar from "../layout/Appbar";
import Breadcrumb from "./Breadcrumb";

function CommonLayout({ title, breadcrumbArr = [], loading = false, children }) {
  return (
    <>
      <Appbar>{title}</Appbar>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) => {
            return theme.palette.TiffanyBlue.main;
          },
          // overflow: "hidden",
          height: "calc(100vh - 45px)",
          marginTop: "1px",
        }}
      >
        {breadcrumbArr.length ? (
          <Paper
            sx={{
              backgroundColor: "white",
              boxShadow: "0px 3px 40px #4343430A",
              p: "4px 10px 4px 30px",
              minHeight: "20px",
              zIndex: (theme) => {
                return theme.zIndex.drawer;
              },
              position: "relative",
            }}
          >
            <Breadcrumb configData={breadcrumbArr} loading={loading} />
          </Paper>
        ) : (
          ""
        )}
        <>{children}</>
      </Box>
    </>
  );
}

export default CommonLayout;
